import $ from 'jquery';

export function correctTelLinks() {
    $('a[href^="tel:"]').each(function () {
        let tel = $(this).attr('href').replace("tel:", "");

        // Vérification du format d'un numéro français
        let regex = /^0[1-9]([ \.-]?\d{2}){4}$/;
        if (regex.test(tel)) {
            let formattedTel = '+33' + tel.substring(1).replace(/\D/g, '');
            $(this).attr('href', 'tel:' + formattedTel);
        }
    });
}
